<template>
    <div id="calendar-filters">
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-30">
                <md-card class="mb-0" style="margin-bottom: 0.375rem !important;">
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="md-layout">
                            <div class="md-layout-item">
                                <div class="card-icon">
                                    <font-awesome-icon class="md-icon" :icon="['fa', 'calendar']" />
                                </div>
                                <h4 class="title">Date</h4>
                            </div>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-40">
                                <div class="md-multiselect">
                                    <label>Mois</label>
                                    <multiselect v-model="filters.date.month"
                                                 :options="months"
                                                 :preserve-search="true" placeholder="Mois"
                                                 :option-height="104"
                                                 label="label" track-by="number"
                                                 :show-labels="false">
                                        <template slot="noOptions">La liste est vide</template>
                                        <template slot="noResult">Aucun élement correspondant</template>
                                    </multiselect>
                                </div>
                            </div>
                            <div class="md-layout-item md-size-25">
                                <div class="md-multiselect">
                                    <label>Année</label>
                                    <multiselect v-model="filters.date.year"
                                                 :options="years"
                                                 :preserve-search="true" placeholder="Année"
                                                 :option-height="104"
                                                 label="label" track-by="number"
                                                 :show-labels="false">
                                        <template slot="noOptions">La liste est vide</template>
                                        <template slot="noResult">Aucun élement correspondant</template>
                                    </multiselect>
                                </div>
                            </div>
                            <div class="md-layout-item md-size-35 text-right">
                                <div class="flex items-center justify-end h-full w-full">
	                                <md-button class="md-default md-icon-button md-raised my-auto" @click="resetDate">
		                                <font-awesome-icon class="md-icon" :icon="['fa', 'calendar']" />
		                                <span class="leading-none ml-2 font-medium">Mois actuel</span>
	                                </md-button>
                                </div>
                            </div>
                        </div>
                    </md-card-content>
                </md-card>
            </div>
            <div class="md-layout-item md-size-70">
                <md-card class="mb-0" style="margin-bottom: 0.375rem !important;">
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="md-layout">
                            <div class="md-layout-item">
                                <div class="card-icon">
                                    <font-awesome-icon class="md-icon" :icon="['fa', 'filter']" />
                                </div>
                                <h4 class="title">Filtres</h4>
                            </div>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-70">
                                <div class="md-multiselect md-multiselect-multiple">
                                    <label>Techniciens</label>
                                    <multiselect v-model="filters.technicians" :multiple="true"
                                                 :close-on-select="true" :clear-on-select="true"
                                                 :options="technicians" :hide-selected="true"
                                                 :option-height="104" :show-labels="false"
                                                 label="full_name" track-by="full_name"
                                                 selectLabel="" selectedLabel="Sélectionné" deselectLabel="Retirer"
                                                 placeholder="Technicien">
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <span class="option__title">
                                                    {{ props.option.full_name }}
                                                </span>
                                            </div>
                                        </template>
                                        <template slot="noOptions">La liste est vide</template>
                                        <template slot="noResult">Aucun élement correspondant</template>
                                    </multiselect>
                                </div>
                            </div>
                            <div class="md-layout-item md-size-30">
                                <div class="flex items-center justify-end w-full h-full space-x-4">
                                    <md-button class="md-success md-icon-button md-raised" @click="filterData"
                                        :disabled="updating">
                                        <font-awesome-icon class="md-icon" :icon="['fa', 'filter']" />
                                        <span class="leading-none ml-2 font-medium">Filtrer</span>
                                    </md-button>
                                    <md-button class="md-default md-icon-button md-raised" @click="resetTechnicians">
                                        <font-awesome-icon class="md-icon" :icon="['fa', 'times-circle']" />
                                        <span class="leading-none ml-2 font-medium">Réinitialiser</span>
                                    </md-button>
                                </div>
                            </div>
                        </div>
                    </md-card-content>
                </md-card>
            </div>
        </div>
        <div class="md-layout md-gutter" id="calendar-filter-week">
            <div class="md-layout-item md-size-100">
                <md-card style="margin: 0.375rem 0 !important;">
                    <md-card-content>
                        <div class="calendar-filters-weeks">
                            <div class="flex items-center w-full justify-between">
                                <md-button class="md-icon-button md-default" :disabled="textPreviousMonth === 'Indisponible'"
                                           @click="previousMonth"
                                           @click.middle="formatQueryToMiddleClick($event, 'previous')">
                                    <div class="pl-2 pr-3 flex items-center">
                                        <font-awesome-icon class="md-icon" :icon="['fa', 'angle-left']" v-if="textPreviousMonth !== 'Indisponible'" />
                                        <span class="leading-none ml-1">{{ textPreviousMonth }}</span>
                                    </div>
                                </md-button>
                                <div class="flex items-center justify-evenly w-full">
                                    <calendar-filter-week-button v-for="week in filters.weeks" :key="week" :week="week"></calendar-filter-week-button>
                                </div>
                                <md-button class="md-icon-button md-default" :disabled="textNextMonth === 'Indisponible'"
                                           @click="nextMonth"
                                           @click.middle="formatQueryToMiddleClick($event,'next')">
                                    <div class="pr-2 pl-3 flex items-center">
                                        <span class="leading-none mr-1">{{ textNextMonth }}</span>
                                        <font-awesome-icon class="md-icon" :icon="['fa', 'angle-right']" v-if="textNextMonth !== 'Indisponible'" />
                                    </div>
                                </md-button>
                            </div>
                        </div>
                    </md-card-content>
                </md-card>
            </div>
        </div>
    </div>
</template>

<script>
import momentRangeMixin from '@/mixins/moment-range-mixin'
import routerMixin from  '@/mixins/router-mixin'
import CalendarFilterWeekButton from "@/pages/Planning/Calendar/components/filter/CalendarFilterWeekButton";
export default {
    name: "CalendarFilters",
    components: {
        CalendarFilterWeekButton
    },
    mixins: [momentRangeMixin, routerMixin],
    props: {
        updating: Boolean
    },
    data() {
        return {
            years: [],
            months: this.$moment.months().map((month, key) => { return { number: key, label: month.charAt(0).toUpperCase() + month.slice(1) }}),
            technicians: [],
            filters: {
                date: {
                    month: null,
                    year: { number: this.$moment().year(), label: this.$moment().year() }
                },
                technicians: [],
                weeks: [],
                watching: false
            }
        }
    },
    computed: {
        textPreviousMonth() {
            if(this.filters.weeks.length > 0) {
                let indexMonth = this.months.findIndex(month => month.number === this.filters.date.month.number)
                let indexYear = this.years.findIndex(year => year.number === this.filters.date.year.number)

                let text
                if(this.months[(indexMonth - 1)]) {
                    text = this.months[(indexMonth - 1)].label + ' ' + this.years[indexYear].label
                } else if(this.years[(indexYear - 1)]) {
                    text = this.months[(this.months.length - 1)].label + ' ' + this.years[(indexYear - 1)].label
                } else {
                    text = 'Indisponible'
                }

                return text
            }
            return ''
        },
        textNextMonth() {
            if(this.filters.weeks.length > 0) {
                let indexMonth = this.months.findIndex(month => month.number === this.filters.date.month.number)
                let indexYear = this.years.findIndex(year => year.number === this.filters.date.year.number)

                let text
                if(this.months[(indexMonth + 1)]) {
                    text = this.months[(indexMonth + 1)].label + ' ' + this.years[indexYear].label
                } else if(this.years[(indexYear + 1)]) {
                    text = this.months[0].label + ' ' + this.years[(indexYear + 1)].label
                } else {
                    text = 'Indisponible'
                }

                return text
            }
            return ''
        }
    },
    methods: {
        async getTechnicians() {
            const { data } = await this.$store.dispatch('users/getTechnicians', {
                isActive: true,
                order: 'order',
                separation: true
            })
            this.technicians = data
            this.checkRouteQuery()
        },
        checkRouteQuery() {
            const { month, year, technicianId } = this.$route.query
            if(month !== undefined && year !== undefined) {
                const filterYear = this.years.find(y => y.number === parseInt(year))
                const filterMonth = this.months.find(m => m.number === parseInt(month))
                const technician = technicianId ? this.technicians.find(tech => tech.id === parseInt(technicianId)) : null
                this.filters = {
                    date: {
                        year: filterYear,
                        month: filterMonth,
                    },
                    technicians: technician ? [technician] : []
                }
            }
            this.filters.watching = true
            this.filterData()
        },
        filterData() {
            if(this.filters.watching) {
                this.$emit('filtered', this.filters)
            }
        },
        resetDate() {
            this.filters.date.month = this.months ? this.months[this.$moment().month()] : null
            this.filters.date.year = { number: this.$moment().year(), label: this.$moment().year() }
            this.formatWeeksFilter()
            this.filterData()
        },
        resetTechnicians() {
            this.filters.technicians = []
            this.filterData()
        },
        formatFilters() {
            this.filters.date.month = this.months ? this.months[this.$moment().month()] : null
            for(let i = -5; i <= 4; i++) {
                this.years.push({
                    number: (this.$moment().year() + i),
                    label: (this.$moment().year() + i)
                })
            }
        },
        previousMonth() {
            if(this.textPreviousMonth !== 'Indisponible') {
                let indexMonth = this.months.findIndex(month => month.number === this.filters.date.month.number)
                let indexYear = this.years.findIndex(year => year.number === this.filters.date.year.number)
                if(indexMonth === 0) {
                    this.filters.date.month = this.months[(this.months.length - 1)]
                    this.filters.date.year = this.years[(indexYear - 1)]
                } else {
                    this.filters.date.month = this.months[(indexMonth - 1)]
                }
                this.filterData()
            }
        },
        nextMonth() {
            if(this.textNextMonth !== 'Indisponible') {
                let indexMonth = this.months.findIndex(month => month.number === this.filters.date.month.number)
                let indexYear = this.years.findIndex(year => year.number === this.filters.date.year.number)
                if(indexMonth === 11) {
                    this.filters.date.month = this.months[0]
                    this.filters.date.year = this.years[(indexYear + 1)]
                } else {
                    this.filters.date.month = this.months[(indexMonth + 1)]
                }
                this.filterData()
            }
        },
        formatWeeksFilter() {
            const month = this.filters.date.month.number
            const year = this.filters.date.year.number

            this.filters.weeks = this.weeksInMonth(year, month)
            this.filterData()
        },
        listenerScroll() {
            // filtre des semaines et bouton pour déselectionner toutes les interventions
            let divWeekFilter = document.getElementById('calendar-filter-week')
            let cardInDivWeekFilter = divWeekFilter.children[0].children[0]
            let buttonClearInterventions = document.getElementById('calendar-clear-interventions')
            if(divWeekFilter && buttonClearInterventions) {
                // élement parent de la div des semaines pour utiliser un élément qui n'est pas modifié
                const offsetTopParentCardWeekFilter = divWeekFilter.parentElement.getBoundingClientRect().top
                // le parent contient aussi les autres filtres, donc il sort de l'écran au scroll
                // quand la card des semaines arrive en haut, l'offset top du parent est négatif
                if(offsetTopParentCardWeekFilter < -95) {
                    const heightNavbar = document.getElementById('main-navbar').offsetHeight
                    const position = 'fixed'
                    const top = { filter: `${heightNavbar}px`, button: `${heightNavbar + divWeekFilter.offsetHeight}px` }
                    const zIndex = '6'
                    const maxWidth = `${divWeekFilter.parentElement.offsetWidth}px`

                    divWeekFilter.style.position = position
                    divWeekFilter.style.top = top.filter
                    divWeekFilter.style.zIndex = zIndex
                    divWeekFilter.style.maxWidth = maxWidth
                    cardInDivWeekFilter.style.backgroundColor = '#eeeeee'

                    buttonClearInterventions.style.position = position
                    buttonClearInterventions.style.top = top.button
                    buttonClearInterventions.style.zIndex = zIndex
                    buttonClearInterventions.style.maxWidth = maxWidth
                } else {
                    divWeekFilter.style.position = 'unset'
                    divWeekFilter.style.top = 'unset'
                    divWeekFilter.style.zIndex = 'unset'
                    divWeekFilter.style.maxWidth = 'unset'
                    cardInDivWeekFilter.style.backgroundColor = '#ffffff'

                    buttonClearInterventions.style.position = 'unset'
                    buttonClearInterventions.style.top = 'unset'
                    buttonClearInterventions.style.zIndex = 'unset'
                    buttonClearInterventions.style.maxWidth = 'unset'
                }
            }
        },
        formatQueryToMiddleClick(event, target) {
            let month, year
            const indexMonth = this.months.findIndex(month => month.number === this.filters.date.month.number)
            const indexYear = this.years.findIndex(year => year.number === this.filters.date.year.number)

            if(target === 'previous') {
                if(indexMonth === 0) {
                    month = this.months[(this.months.length - 1)]
                    year = this.years[(indexYear - 1)]
                } else {
                    month = this.months[(indexMonth - 1)]
                    year = this.years[indexYear]
                }
            } else if(target === 'next') {
                if(indexMonth === 11) {
                    month = this.months[0]
                    year = this.years[(indexYear + 1)]
                } else {
                    month = this.months[(indexMonth + 1)]
                    year = this.years[indexYear]
                }
            }
            const params = {}
            const query = { month: month.number, year: year.number }
            const route = this.$router.resolve({ name: 'Calendar', params, query })
            window.open(route.href, '_blank')
        }
    },
    mounted() {
        this.formatFilters()
        this.formatWeeksFilter()
        this.getTechnicians()
        window.addEventListener('scroll', this.listenerScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.listenerScroll)
    },
    watch: {
        'filters.date.month': {
            deep: true,
            handler: function(newVal, oldVal) {
                if(newVal === null) {
                    this.filters.date.month = oldVal
                }
                if(this.filters.watching) {
                    this.formatWeeksFilter()
                }
            },
        },
        'filters.date.year': {
            deep: true,
            handler: function(newVal, oldVal) {
                if(newVal === null) {
                    this.filters.date.month = oldVal
                }
                if(this.filters.watching) {
                    this.formatWeeksFilter()
                }
            },
        },
    }
}
</script>

<style scoped lang="scss">
.md-layout.md-gutter {
    margin: 0;
    .md-layout-item {
        padding: 0 10px;

        &:first-child {
            padding-left: 0;
        }

        &:last-child {
            padding-right: 0;
        }
    }
}

::v-deep {
    .md-card.mb-0 {
        margin-bottom: 0 !important;
    }
}
</style>
